module.exports = __webpack_public_path__ + "font/bc6fdf7cd9e3267ff6168363266d0a19.otf";